const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { prescription: prescriptionApi } = require('@doctoroncallcom/api')
const {
  // For Admin Panel
  GET_PRESCRIPTION_LIST,
  GET_PRESCRIPTION,
  CREATE_PRESCRIPTION,
  UPDATE_PRESCRIPTION,
  DELETE_PRESCRIPTION,
  UPDATE_PRESCRIPTION_STATUS,
  ADD_PRESCRIPTION_VALIDITY,

  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA,
  POST_DOCTOR_PRESCRIPTION_DATA,
  GET_PATIENT_PRESCRIPTION_DATA,
  GET_MD_PRESCRIPTION_NEW_LINK,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA,
  POST_FOR_PRESCRIPTION_NOTIFICATION,
} = require('./constants')

const {
  // For Admin Panel
  getPrescriptionListSuccess,
  getPrescriptionListError,
  getPrescriptionSuccess,
  getPrescriptionError,
  createPrescriptionSuccess,
  createPrescriptionError,
  updatePrescriptionSuccess,
  updatePrescriptionError,
  deletePrescriptionSuccess,
  deletePrescriptionError,
  updatePrescriptionStatusSuccess,
  updatePrescriptionStatusError,
  addPrescriptionValiditySuccess,
  addPrescriptionValidityError,

  // ====
  postDoctorPrescriptionSearchValueSuccess,
  postDoctorPrescriptionSearchValueError,
  postDoctorPrescriptionDataSuccess,
  postDoctorPrescriptionDataError,
  getPatientPrescriptionDataSuccess,
  getPatientPrescriptionDataError,
  getMDPrescriptionNewLinkSuccess,
  getMDPrescriptionNewLinkError,

  postDoctorEditPrescriptionSearchValueSuccess,
  postDoctorEditPrescriptionSearchValueError,
  postForPrescriptionNotificationDataSuccess,
  postForPrescriptionNotificationDataError,
} = require('./actions')

// For Admin Panel
const getPrescriptionList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRESCRIPTION_LIST),
  mergeMap(action => prescriptionApi.getPrescriptionListApi(api, {
    take: action.payload.take,
    skip: action.payload.skip,
    doctorId: action.payload.doctorId,
    patientId: action.payload.patientId,
    all: action.payload.all,
    download: action.payload.download,
    search: action.payload.search,
    status: action.payload.status,
    id: action.payload.id,
    from: action.payload.from,
    to: action.payload.to,
    date: action.payload.date,
  })
    .then(response => getPrescriptionListSuccess(response.data))
    .catch(error => getPrescriptionListError(error))),
)

// For Admin Panel
const getPrescription = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRESCRIPTION),
  mergeMap(action => prescriptionApi.getPrescriptionApi(api, action.payload.id)
    .then(response => getPrescriptionSuccess(response.data))
    .catch(error => getPrescriptionError(error))),
)

// For Admin Panel
const createPrescription = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_PRESCRIPTION),
  mergeMap(action => prescriptionApi.createPrescriptionApi(api, action.payload.prescriptionData)
    .then(response => createPrescriptionSuccess(response.data))
    .catch(error => createPrescriptionError(error))),
)

// For Admin Panel
const updatePrescription = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PRESCRIPTION),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.updatePrescriptionApi(api, action.payload.id, action.payload.prescriptionData)
    .then(response => updatePrescriptionSuccess(response.data))
    .catch(error => updatePrescriptionError(error))),
)

// For Admin Panel
const deletePrescription = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_PRESCRIPTION),
  mergeMap(action => prescriptionApi.deletePrescriptionApi(api, action.payload.id)
    .then(response => deletePrescriptionSuccess(response.data))
    .catch(error => deletePrescriptionError(error))),
)

// For Admin Panel
const updatePrescriptionStatus = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PRESCRIPTION_STATUS),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.updatePrescriptionStatusApi(api, action.payload.id, action.payload.statusData)
    .then(response => updatePrescriptionStatusSuccess(response.data))
    .catch(error => updatePrescriptionStatusError(error))),
)

// For Admin Panel
const addPrescriptionValidity = (action$, state$, { api }) => action$.pipe(
  ofType(ADD_PRESCRIPTION_VALIDITY),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.addPrescriptionValidityApi(api, action.payload.id, action.payload.date)
    .then(response => addPrescriptionValiditySuccess(response.data))
    .catch(error => addPrescriptionValidityError(error))),
)

const postDoctorPrescriptionSearchEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_PRESCRIPTION_SEARCH_DATA),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.postDoctorPrescriptionSearchValueApi(api, { search: action.payload.data })
    .then(response => postDoctorPrescriptionSearchValueSuccess(response.data))
    .catch(error => postDoctorPrescriptionSearchValueError(error))),
)

const postDoctorPrescriptionDataEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_PRESCRIPTION_DATA),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.postDoctorPrescriptionDataApi(api, action.payload.data, action.payload.id)
    .then(response => postDoctorPrescriptionDataSuccess(response.data))
    .catch(error => postDoctorPrescriptionDataError(error))),
)

const getPatientPrescriptionDataEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PATIENT_PRESCRIPTION_DATA),
  mergeMap(action => prescriptionApi.getPatientPrescriptionDataApi(api, action.payload.id)
    .then(response => getPatientPrescriptionDataSuccess(response.data))
    .catch(error => getPatientPrescriptionDataError(error))),
)

const getDoctorPrescriptionNewLinkEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_MD_PRESCRIPTION_NEW_LINK),
  mergeMap(action => prescriptionApi.getDoctorPrescriptionNewLinkApi(
    api,
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => getMDPrescriptionNewLinkSuccess(response.data))
    .catch(error => getMDPrescriptionNewLinkError(error))),
)

const postDoctorEditPrescriptionSearchEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.postDoctorEditPrescriptionSearchValueApi(api, { search: action.payload.data })
    .then(response => postDoctorEditPrescriptionSearchValueSuccess(response.data))
    .catch(error => postDoctorEditPrescriptionSearchValueError(error))),
)

const postForPrescriptionNotificationDataEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_FOR_PRESCRIPTION_NOTIFICATION),
  // eslint-disable-next-line max-len
  mergeMap(action => prescriptionApi.postForPrescriptionNotificationDataApi(api, action.payload.data, { doctorId: action.payload.id })
    .then(response => postForPrescriptionNotificationDataSuccess(response.data))
    .catch(error => postForPrescriptionNotificationDataError(error))),
)

module.exports = {
  // For Admin Panel
  getPrescriptionList,
  getPrescription,
  createPrescription,
  updatePrescription,
  deletePrescription,
  updatePrescriptionStatus,
  addPrescriptionValidity,

  // ===
  postDoctorPrescriptionSearchEpic,
  postDoctorPrescriptionDataEpic,
  getPatientPrescriptionDataEpic,
  getDoctorPrescriptionNewLinkEpic,
  postDoctorEditPrescriptionSearchEpic,
  postForPrescriptionNotificationDataEpic,
}
